import { ClientAccountWithAnalyticSummary } from '@lune-climate/lune'
import { PaginationKeys, usePaginationState } from '@lune-fe/lune-components-lib'
import { TableNew } from '@lune-fe/lune-ui-lib'
import { FC, RefObject } from 'react'
import { useNavigate } from 'react-router-dom'

import AccountNameAndLogoTile from 'components/AccontNameAndLogoTile'
import { formatNumberWithFallback, formatRelativeTime } from 'utils'
import { ClientAccountsContextMenu, PublicPagesButtonAndModal } from 'views/Settings/ClientAccounts'

const ClientAccountsTableRow: FC<{
    account: ClientAccountWithAnalyticSummary
    currentPage: number
    pageHistoryRef: RefObject<(string | undefined)[]>
}> = ({ account, currentPage, pageHistoryRef }) => {
    const navigate = useNavigate()
    const { savePaginationState } = usePaginationState()

    return (
        <TableNew.TableRow
            hover
            onClick={() => {
                savePaginationState(
                    PaginationKeys.IMPORTS,
                    currentPage,
                    pageHistoryRef.current ?? [undefined],
                )
                navigate(`/client-accounts/${account.id}`)
            }}
            data-testid={account.id}
            sx={{
                ...{
                    '&:hover': {
                        '.context-menu': {
                            opacity: 1,
                        },
                    },
                },
            }}
        >
            <TableNew.TableCell colSize={5}>
                <AccountNameAndLogoTile logo={account.logo} accountName={account.name} />
            </TableNew.TableCell>
            <TableNew.TableCell colSize={2}>
                {formatRelativeTime(account.lastActiveDate)}
            </TableNew.TableCell>
            <TableNew.TableCell colSize={2} alignEnd>
                {formatNumberWithFallback(account.numberOfEstimates, {
                    fallback: '--',
                })}
            </TableNew.TableCell>
            <TableNew.TableCell colSize={2} alignEnd>
                {formatNumberWithFallback(account.totalEmissions, {
                    decimals: 2,
                    decimalsWhenLessThan: 6,
                    fallback: '--',
                })}
            </TableNew.TableCell>
            <TableNew.TableCell
                onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                }}
                alignEnd
                colSize={1}
                sx={{
                    '.context-menu': {
                        opacity: 0,
                    },
                    '&:hover': {
                        '.context-menu': {
                            opacity: 1,
                        },
                    },
                }}
            >
                <PublicPagesButtonAndModal account={account} />
                <ClientAccountsContextMenu account={account} />
            </TableNew.TableCell>
        </TableNew.TableRow>
    )
}

export default ClientAccountsTableRow
